module.exports = __webpack_public_path__ + "images/emoji/clubs.caadca3f1418301afb93.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clubs.png
// module id = hlwa
// module chunks = 1